<div class="source-select">
    <div class="input-wrapper">
        <input
            type="text"
            [placeholder]="displayValue || ''"
            [(ngModel)]="searchText"
            (ngModelChange)="onSearchChange()"
            (focus)="onFocus()"
            (blur)="onBlur()"
            (keydown)="onKeyDown($event)"
        />
        <div *ngIf="displayValue" class="clear-btn" (mousedown)="clearSelection($event)" title="Clear">&times;</div>
    </div>
    <div *ngIf="isOpen && options && options.length > 0" class="options">
        <div *ngFor="let option of options; let i = index"
             class="option"
             [class.selected]="selectedIndex === i"
             (mousedown)="selectOption(option)">
            <div class="count">{{ option.count | rf:'number' }}</div>
            {{ option.display }}
        </div>
        <div *ngIf="moreCount > 0" class="option no-results more">{{ moreCount | rf:'number' }} more &mdash; type to search</div>
    </div>
    <div *ngIf="isOpen && options && options.length === 0" class="options">
        <div class="option no-results">No results</div>
    </div>
</div>
